export default function($) {

  var IwProductMultiSelect = function(element, wrapper){
    // we do nothing is the selector is not found
    if (element.length) {
      this.element = element;
      this.wrapper = wrapper;
      this.productVariationElements = this.wrapper.find('.js-iw-product-variation');
      this.dataInputPrefix = "iw_";
      this.actionClass = "js-iw-multiselect-product-variation-link";
      this.inputTag = null;

      this.renderBaseFeatureComponent();

      var self = this;
      this.element.find("."+this.actionClass).click(function(event) {
        event.preventDefault();
        if (self.validation()) {
          self.setVariationsQuantities();
        }
      })
    }
  }

  IwProductMultiSelect.prototype = {
    renderBaseFeatureComponent: function() {
      //the parent element contain all default | client specific html tags in data attributes prefixed with this.dataInputPrefix
      // This is because we do not want this to work if no javascript enabled so we can't render the input in backend.

      var dataAttributesHandler = {
        init: function(inputDataPrefix, data) {
          this.prefix = inputDataPrefix;
          this.dataObject = data;
        },
        inputTagsString: function() {
          var inputTagPropertyNames = Object.getOwnPropertyNames(this.dataObject).filter(
            function(property) {
              if (typeof this.dataObject[property] === 'function') {
                return false;
              }
              return property.indexOf(this.prefix) !== -1;
            },
            this
          );

          var inputTagsArray = [];
          for (var key in inputTagPropertyNames) {
            var propertyKey = inputTagPropertyNames[key];
            var tagKey = propertyKey.replace(this.prefix, "");
            inputTagsArray.push(tagKey+"=\""+this.dataObject[propertyKey]+"\"");
          }

          return inputTagsArray.join(" ");
        },
      };

      dataAttributesHandler.init(this.dataInputPrefix, this.element.data());

      var strInputTag = "<input ";
      strInputTag += dataAttributesHandler.inputTagsString();
      strInputTag += ">";

      var inputTag = $(strInputTag);
      var inputTagName = inputTag.prop("name");
      if (inputTagName === "undefined") {
        inputTagName = "iw-multiselect-product-variation-quantity";
      }

      var labelTag = $("<label for=\""+inputTagName+"\">Commande rapide : </label>");

      var linkTag = $("<a href=\"#0\" class=\""+this.actionClass+"\">Ajouter</a>");

      this.inputTag = inputTag;
      this.element.append("<p>");
      this.element.append(labelTag);
      this.element.append("<span>ajouter toutes les variations ci-dessous un même nombre de fois : </span> ");
      this.element.append(inputTag);
      this.element.append(linkTag);
      this.element.append("</p>");
    },
    validation: function() {
      var providedQty = parseInt(Number(this.element.find('input').val()));
      return !(isNaN(providedQty));
    },
    setVariationsQuantities: function() {
      self = this;
      var providedQty = parseInt(Number(this.element.find('input').val()));
      this.productVariationElements.each(function () {
        $(this).find(".js-variation_quantity_selector").val(providedQty);
        if (self.inputTag !== null) {
          self.inputTag.val(0);
        }
      });
    }
  }

  $(document).ready(function () {
    $('.js-iw-product-wrapper').each(function () {
      var multiselector = $(this).find('.js-iw-product-multiselector');
      var iwms = new IwProductMultiSelect(multiselector, $(this));
    })
  })

}
